export const PaymentRequestStatus = {
    PAID: 'PAID',
    PENDING: 'PENDING',
    NEVER_PAID: 'NEVER_PAID',
    DUPLICATED: 'DUPLICATED',
}